import requestAction from '../../utils/requestAction';
import MassNotification from '../../models/MassNotification';

export const fetchMassNotification = (id: string, handleResponse?: (massNotification: MassNotification) => void) =>
  requestAction('MASS_NOTIFICATION_DETAIL')(`massNotifications/${id}`, 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.massNotification) });
